import Splide from "@splidejs/splide";

new Splide('.employee-list-location-slider', {
    mediaQuery: "min", // mobile first
    perPage: 1,
    arrows: false,
    // Tablet
    breakpoints: {
        576: {
            perPage: 2,
            gap: '1.5rem',
            arrows: true,
            pagination: false,
        }
    }
}).mount();
